import {
  MeModule,
  MeResponse,
  MeTable,
} from '~shared/models/me-response.model';
import { Module } from '~shared/models/module.model';
import { Table } from '~shared/models/table.model';

function mapMeTable(table: MeTable): Table {
  return {
    id: table.id,
    name: table.name,
    techname: table.techname,
    description: table.description ?? '',
    enabled: table.enabled,
    slug: table.slug,
  };
}

function mapMeModule(module: MeModule): Module {
  return {
    id: module.id,
    name: module.name,
    description: module.description,
    icon: module.icon,
    slug: module.slug,
    tables: module.tables.map(mapMeTable),
  };
}

/** Modules du menu, tels que /me les accorde à l'utilisateur courant. */
export function mapMeModules(me: MeResponse): Module[] {
  return me.permissions.modules.map(mapMeModule);
}
